import { InvoiceTabEffects } from '@invoices-store/effects/invoice-tab.effects';

export const invoicesEffects = [
	InvoiceTabEffects,
];
